import {fetch} from "utils/dataAccess";

export function generateExpeditionList(shipmentList) {
    return fetch('/expedition_lists/generate', {
        method: "POST",
        headers: new Headers({'Content-Type': 'application/json'}),
        body: JSON.stringify({
            shipment_list: shipmentList,
        })
    }).then(response => response.json());
}